import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import {Button} from 'antd';
import InvoiceSelector from '../InvoiceSelector';
import UpdateBillForm from '../UpdateBillForm';
import UpdateVendorForm from '../UpdateVendorForm';
import TransactionDetailsPanel from '../../TransactionsPage/TransactionDetailsPanel';
import {accountingEditVariants} from '../../../../constants';

const { INVOICE_MATCHING, BILL_MISSING, VENDOR_MISSING } = accountingEditVariants;

const EditAccountingRowSection = ({
  dispatch,
  item,
  onBack,
  onSuccess,
  variant,
  ...rest
}) => {
  const [t] = useTranslation(['main']);
  const [submitButtonProps, setSubmitButtonProps] = React.useState({loading: false});

  const invoiceFormRef = React.useRef(null);
  const vendorFormRef = React.useRef(null);

  const backButtonText = useMemo(() => ({
    [INVOICE_MATCHING]: `${t('add')} ${t('bill')}`,
    [BILL_MISSING]: `${t('update')} ${t('bill')}`,
    [VENDOR_MISSING]: `${t('update')} ${t('vendor')}`,
  }[variant] || t('back')), [t, variant]);

  const formProps = { onSuccess, setSubmitButtonProps };

  const content = {
    [INVOICE_MATCHING]: <InvoiceSelector transaction={item} onSuccess={onSuccess} />,
    [BILL_MISSING]: <UpdateBillForm {...formProps} entry={item} ref={invoiceFormRef} />,
    [VENDOR_MISSING]: <UpdateVendorForm {...formProps} vendor={item?.vendor} ref={vendorFormRef} />,
  }[variant] || '';

  const handleSubmitForm = () => {
    const actions = {
      [BILL_MISSING]: () => invoiceFormRef?.current?.submit(),
      [VENDOR_MISSING]: () => vendorFormRef?.current?.submit()
    }
    actions[variant]?.();
  }

  const footer = variant !== INVOICE_MATCHING ? (
    <Button
      {...submitButtonProps}
      onClick={handleSubmitForm}
      size='large'
      type='primary'
    >
      {t('update')}
    </Button>
  ) : null;

  return (
    <TransactionDetailsPanel
      backButtonText={backButtonText}
      onBack={onBack}
      footer={footer}
      {...rest}
    >
      {content}
    </TransactionDetailsPanel>
  );
}

EditAccountingRowSection.propTypes = {
  transaction: PropTypes.object,
  onBack: PropTypes.func,
}

export default EditAccountingRowSection;
